import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Renders section content: GFM tables become <table>, [TO CONFIRM: …] placeholders are highlighted. */
export default function Markdown({ text, fixed }: { text: string; fixed?: string[] }) {
  // Split out fixed passages (mandatory text / reference tables) so they render as such.
  let parts: Array<{ kind: "model" | "fixed"; text: string }> = [{ kind: "model", text }];
  for (const f of fixed ?? []) {
    if (!f) continue;
    parts = parts.flatMap((p) => {
      if (p.kind !== "model" || !p.text.includes(f)) return [p];
      const [before, ...rest] = p.text.split(f);
      const out: typeof parts = [];
      if (before?.trim()) out.push({ kind: "model", text: before });
      out.push({ kind: "fixed", text: f });
      const after = rest.join(f);
      if (after.trim()) out.push({ kind: "model", text: after });
      return out;
    });
  }
  return (
    <div className="md">
      {parts.map((p, i) => (
        <div key={i} className={p.kind === "fixed" ? "fixed-text" : undefined} title={p.kind === "fixed" ? "Fixed text from tenant policy or reference data" : undefined}>
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ p: ({ children }) => <p>{highlight(children)}</p>, li: ({ children }) => <li>{highlight(children)}</li> }}>{listsStandApart(p.text)}</ReactMarkdown>
        </div>
      ))}
    </div>
  );
}

const LIST_LINE = /^\s*(\d+[.)]|[-*+•])\s+/;
/** KRE-124: a list that follows a sentence directly starts a list, whatever number it starts at. In CommonMark a list
 *  starting at anything but 1 cannot interrupt a paragraph, so "… for:\n4. a\n5. b" read as one line; Word already
 *  read it as a list. A blank line before such a list makes the two agree. */
export function listsStandApart(text: string): string {
  const lines = text.split("\n");
  const out: string[] = [];
  lines.forEach((line, i) => {
    const prev = lines[i - 1];
    if (i > 0 && LIST_LINE.test(line) && prev !== undefined && prev.trim() && !LIST_LINE.test(prev) && !prev.trim().startsWith("|") && !/^\s{2,}/.test(prev)) out.push("");
    out.push(line);
  });
  return out.join("\n");
}

const PLACEHOLDER = /(\[TO CONFIRM:[^\]]*\])/g;
function highlight(children: React.ReactNode): React.ReactNode {
  if (typeof children === "string") return children.split(PLACEHOLDER).map((s, i) => (PLACEHOLDER.test(s) ? <mark key={i} className="placeholder">{s}</mark> : s));
  if (Array.isArray(children)) return children.map((c, i) => <span key={i}>{highlight(c)}</span>);
  return children;
}
